import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { GatewayCustomerModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/customers/models/outputs/gateway-customer.model';
import { CellContext } from '@tanstack/react-table';

export interface CustomerListNameCellProps
  extends CellContext<GatewayCustomerModel, GatewayCustomerModel['name']> {}

export const CustomerListNameCell = (
  props: CustomerListNameCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  return <Text truncate>{getValue()}</Text>;
};
